/**
 * TDS · PUENTE TEMPORAL: reglas de recomendados en el carrito lateral.
 *
 * El panel de Carrito Lateral ya permite decir "si el carrito lleva ESTO,
 * ofrece ESTO OTRO", pero esa lógica vive en el archivo del cajón, que se
 * publica con `shopify app deploy --config carrito-lateral`. Mientras no se
 * publique, la versión que sirve la tienda no reconoce el modo "reglas" y
 * cae en el automático: recomienda lo que le parece a la tienda, que no es
 * lo que el merchant configuró.
 *
 * Este puente lee la MISMA configuración del panel (/apps/carrito/config),
 * aplica las reglas y repinta la sección de recomendados del cajón con el
 * mismo aspecto que tiene la suya. En cuanto se despliegue el cajón nuevo,
 * se quita el render de este snippet en theme.liquid y ya está: no hay dos
 * sistemas conviviendo, solo uno cubriendo al otro hasta entonces.
 *
 * Sin console.log.
 */
(function () {
  'use strict';

  var TDS_L = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "").slice(0, 2);
  /*
   * Textos que ve el cliente en de/en/it ('' en español). Los del panel de
   * la app (/apps/carrito/config) están siempre en español —el panel no
   * distingue idioma—, así que fuera del español mandan estos. En español
   * no cambia nada: siguen mandando el panel y los de siempre.
   */
  var TDS_TITULO = TDS_L === "de" ? "Das könnte dir auch gefallen" : TDS_L === "en" ? "You may also like" : TDS_L === "it" ? "Potrebbe piacerti anche" : '';
  var TDS_ANADIR = TDS_L === "de" ? "Hinzufügen" : TDS_L === "en" ? "Add" : TDS_L === "it" ? "Aggiungi" : '';
  var TDS_ANADIENDO = TDS_L === "de" ? "Wird hinzugefügt…" : TDS_L === "en" ? "Adding…" : TDS_L === "it" ? "Aggiunta in corso…" : '';

  var CONFIG = '/apps/carrito/config';
  var CAJA_REC = '[data-cd-recomendados]';
  var MARCA = 'data-tds-reglas';

  var ajustes = null;
  var cacheProducto = {};
  var pintando = false;
  /**
   * El cajón repinta a menudo y cada repintado dispara el observador: sin
   * caché, /cart.js se pedía decenas de veces seguidas y Shopify acababa
   * respondiendo 429 (demasiadas peticiones), que deja al cliente con el
   * carrito a medias. Con dos segundos de memoria basta: el carrito solo
   * cambia cuando el propio cliente lo toca, y entonces se invalida a mano.
   */
  var cacheCarrito = null;
  var cacheCarritoEn = 0;
  var MEMORIA_CARRITO = 2000;
  /**
   * El cajón repinta sus recomendados sobre el MISMO contenedor
   * (caja.innerHTML = …), así que marcar el nodo no sirve para saber si
   * sigue estando lo nuestro: la marca sobrevive al repintado. Se guarda el
   * HTML que dejamos y se compara; si no coincide, es que lo ha pisado.
   */
  var ultimoHTML = null;

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function euros(centimos) {
    return (Number(centimos || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function handleDe(u) {
    return typeof u === 'string' ? u : (u && u.handle) || '';
  }

  function pedirConfig() {
    if (ajustes) return Promise.resolve(ajustes);
    return fetch(CONFIG, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { ajustes = (j && j.ajustes) || null; return ajustes; })
      .catch(function () { return null; });
  }

  /** Datos de un producto para pintarlo: precio, variante y foto. */
  function producto(handle) {
    if (cacheProducto[handle] !== undefined) return Promise.resolve(cacheProducto[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = p && (p.variants || []).filter(function (x) { return x.available; })[0];
        cacheProducto[handle] = v
          ? {
              titulo: p.title,
              precio: v.price,
              variante: v.id,
              foto: p.featured_image || (p.images && p.images[0]) || '',
            }
          : null;
        return cacheProducto[handle];
      })
      .catch(function () { cacheProducto[handle] = null; return null; });
  }

  function pintar(caja, titulo, lista, textoBoton) {
    caja.setAttribute(MARCA, '');
    if (!lista.length) { caja.innerHTML = ''; ultimoHTML = caja.innerHTML; return; }
    caja.innerHTML =
      '<div class="cd-upsells"><h3>' + esc(TDS_TITULO || titulo || 'También te puede gustar') + '</h3>' +
      lista.map(function (p) {
        return (
          '<div class="cd-upsell">' +
            '<img src="' + esc(p.foto) + '" alt="" loading="lazy" width="54" height="54">' +
            '<div>' +
              '<p class="cd-upsell-nombre">' + esc(p.titulo) + '</p>' +
              '<p class="cd-upsell-precio">' + euros(p.precio) + '</p>' +
            '</div>' +
            '<button type="button" data-tds-add="' + p.variante + '">' + esc(TDS_ANADIR || textoBoton || 'Añadir') + '</button>' +
          '</div>'
        );
      }).join('') + '</div>';
    ultimoHTML = caja.innerHTML;
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('[data-tds-add]') : null;
    if (!b) return;
    ev.preventDefault();
    ev.stopPropagation();
    var textoOrig = b.textContent;
    b.disabled = true;
    b.textContent = TDS_ANADIENDO || (ajustes && ajustes.textos && ajustes.textos.anadiendo) || 'Añadiendo…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(b.getAttribute('data-tds-add')), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        ultimoHTML = null;
        cacheCarrito = null;
        // El cajón se entera solo (intercepta /cart/add.js y se refresca).
        setTimeout(revisar, 700);
      })
      .catch(function () { b.disabled = false; b.textContent = textoOrig; });
  }, true);

  function revisar() {
    var caja = document.querySelector(CAJA_REC);
    if (!caja || pintando) return;

    pedirConfig().then(function (a) {
      if (!a) return;
      var rec = a.recomendados || {};
      // Solo cuando el merchant ha elegido el modo por reglas: en manual o
      // automático manda el cajón, que ya sabe hacerlo.
      if (!rec.activo || rec.modo !== 'reglas') return;

      pintando = true;
      var pedirCarrito = (cacheCarrito && Date.now() - cacheCarritoEn < MEMORIA_CARRITO)
        ? Promise.resolve(cacheCarrito)
        : fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (j) { cacheCarrito = j; cacheCarritoEn = Date.now(); return j; });
      pedirCarrito
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var dentro = {};
          items.forEach(function (i) { dentro[i.handle] = true; });

          var regla = null;
          (rec.reglas || []).some(function (r2) {
            var acierta = ((r2 && r2.cuando) || []).some(function (u) {
              var h = handleDe(u);
              return h && dentro[h];
            });
            if (acierta && ((r2.ofrece || []).length)) { regla = r2; return true; }
            return false;
          });

          if (!regla) {
            // Sin regla que case no se enseña nada: el automático del cajón
            // propondría cualquier cosa, que es justo lo que se quiere evitar.
            if (caja.innerHTML !== '') pintar(caja, '', [], '');
            pintando = false;
            return;
          }

          var handles = regla.ofrece
            .map(handleDe)
            .filter(function (h) { return h && !dentro[h]; })
            .slice(0, rec.cantidad || 4);

          Promise.all(handles.map(producto)).then(function (prods) {
            var buenos = prods.filter(Boolean);
            var cajaAhora = document.querySelector(CAJA_REC) || caja;
            pintar(cajaAhora, rec.titulo, buenos, a.textos && a.textos.anadir);
            pintando = false;
          });
        })
        .catch(function () { pintando = false; });
    });
  }

  // El cajón repinta su contenido cuando quiere: se vigila el DOM y se
  // vuelve a aplicar la regla si ha borrado lo nuestro.
  var tic = null;
  function programar() {
    clearTimeout(tic);
    tic = setTimeout(revisar, 250);
  }
  if ('MutationObserver' in window) {
    var vigilar = function () {
      if (!document.body) return;
      new MutationObserver(function () {
        var caja = document.querySelector(CAJA_REC);
        if (!caja) return;
        // Lo nuestro sigue ahí → nada que hacer. Si el cajón lo ha pisado
        // con sus recomendados automáticos, se vuelve a aplicar la regla.
        if (ultimoHTML !== null && caja.innerHTML === ultimoHTML) return;
        programar();
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) vigilar();
    else document.addEventListener('DOMContentLoaded', vigilar);
  }
  ['cart:refresh', 'cart:updated', 'cart:open', 'cd:open', 'cd:refresh']
    .forEach(function (ev) { document.addEventListener(ev, programar, true); });
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('a[href*="/cart"], [data-cd-abrir], .cd-flotante')) programar();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar);
  else programar();
})();
